(function () {
    "use strict";

    angular
        .module("app")
        .component("chooseProductContent", { // choose-product-content
            templateUrl: "src/app/login/chooseProductContent.html",
            controller: controller,
            bindings: {
                onContinue: "&",
                onCancel: "&"
            }
        });

    function controller(session, toast, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;
        $ctrl.ui = {
            busy: false
		};

        $ctrl.productSelected = cartTypeCode => {
            $ctrl.ui.busy = true;
            session
                .setCartType(cartTypeCode)
                .then(() => {
                    $ctrl.onContinue();
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

    }
    controller.$inject = ["sessionService", "stToastFactory", "CART_TYPE_CODE"];

})()